import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { FiYoutube, FiInstagram } from "react-icons/fi";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container-fluid">
          <div className="footer-top">
            <div className="row row-cols-xl-4 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 justify-content-center g-lg-4 gy-5 ">
              <div className="col d-flex justify-content-lg-start">
                <div className="footer-widget">
                  <div className="footer-logo">
                  <Link to="/">
                  <img src="/assets/img/logo.png" alt="Baby Twinkles" style={{ maxHeight: "100px" }} />

                  </Link>
                  </div>
                  <div className="footer-content">
                    <p style={{ color: 'white' }}>Capturing precious moments of your little ones with professional photography services. We specialize in newborn, baby, and family photography.</p>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-sm-center">
                <div className="footer-widget">
                  <div className="widget-title">
                    <h5 style={{ color: 'white' }}>Quick Links</h5>
                  </div>
                  <div className="menu-container">
                    <ul>
                      <li>
                        <Link to="/about" style={{ color: 'white' }}>
                          About Us
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/gallery" style={{ color: 'white' }}>
                          Gallery
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/blogs" style={{ color: 'white' }}>
                          Blog
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Contact Us
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          FAQ
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-lg-center justify-content-sm-end">
                <div className="footer-widget">
                  <div className="widget-title">
                    <h5 style={{ color: 'white' }}>Services</h5>
                  </div>
                  <div className="menu-container">
                    <ul>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Newborn Photography
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Baby Sessions
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Cake Smash
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Birthday Photography
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" style={{ color: 'white' }}>
                          Family Photography
                          <FiArrowUpRight className="ms-1" size={14} />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
                <div className="footer-widget">
                  <div className="widget-title">
                    <h5 style={{ color: 'white' }}>Contact Details</h5>
                  </div>
                  <div className="contact-info">
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                      <li style={{ listStyleType: "none", display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <FiPhone style={{ color: "white" }} size={18} />
                        <a href="tel:+918074597649" style={{ color: 'white', textDecoration: 'underline', margin: 0 }}>
                         +91 8074 597 649
                        </a>
                      </li>
                      <li style={{ listStyleType: "none", display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
                        <FiMail style={{ color: "white" }} size={18} />
                        <a href="mailto:Babytwinklespic1@gmail.com" style={{ color: 'white', textDecoration: 'underline', margin: 0 }}>
                          Babytwinklespic1@gmail.com
                        </a>
                      </li>
                      <li style={{ listStyleType: "none", display: "flex", alignItems: "flex-start", gap: "12px" }}>
                        <FiMapPin style={{ color: "white" }} size={18} />
                        <p style={{ color: 'white', margin: 0 }}>Avana Apartments, Road No. 47, Ayyappa Society, Madhapur, Hyderabad, Telangana 500081</p>
                      </li>
                    </ul>
                  </div>
              </div>
            </div>
          </div>
          <div className="footer-btm">
            <div className="copyright-area">
              <p>
                Copyright 2026{" "}
                <a href="#" target="_blank">
                  Baby Twinkles Photography
                </a>{" "}
                | Design By{" "}
                <a
                  href="https://webdigihr.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: "linear-gradient(90deg, #732d92, #5c8712)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: "800",
                    textDecoration: "none",
                  }}
                >
                  WebDigiHr
                </a>
              </p>
            </div>

                 <div className="copyright-area">
              <p>
             <Link to="/terms-and-conditions">Terms & Conditions</Link>  
              </p>
            </div>  

            <div className="social-area">
              <h6>Follow Baby Twinkles:</h6>
              <ul>
                <li>
                  <a href="https://www.youtube.com/channel/UCzbkogEYyPKFuIZl1HGq9pA" target="_blank" rel="noopener noreferrer">
                    <FiYoutube size={20} />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/baby_twinkles_photography/?hl=en" target="_blank" rel="noopener noreferrer">
                    <FiInstagram size={20} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
  
export default Footer;
